import { loadingSpinnerActions } from "../../actions/loadingSpinnerActions";
import { switchTenantActions } from "../../actions/switchTenantActions";
var UnauthUserReduxProps = {
    mapDispatchToProps: function (dispatch) {
        return {
            onShowSpinner: function () { return dispatch({ type: loadingSpinnerActions.SHOW_SPINNER_MODAL }); },
            onHideSpinner: function () { return dispatch({ type: loadingSpinnerActions.HIDE_SPINNER_MODAL }); },
            onShowSwitchTenantButton: function () { return dispatch({ type: switchTenantActions.SHOW_SWITCH_TENANT_BUTTON }); },
            onHideSwitchTenantButton: function () { return dispatch({ type: switchTenantActions.HIDE_SWITCH_TENANT_BUTTON }); }
        };
    }
};
export default UnauthUserReduxProps;



//////////////////
// WEBPACK FOOTER
// ./src/views/UnauthUser/UnauthUserReduxProps.ts
// module id = 628
// module chunks = 0